import { Injectable } from "@angular/core";
import { Agreements } from "../svg-paths/agreements";

@Injectable({ providedIn: "root" })
export class LogoService {
  // Default Nexu lockup shown when no brand subdomain matches.
  public static readonly NEXU_DEFAULT_LOGO =
    "https://nexu-rebranding-2025.s3.us-east-1.amazonaws.com/logo/svg/lockup-black.svg";

  private readonly logoMap: { prefix: string; logo: string }[] = [
    { prefix: "kia", logo: Agreements.kia },
    { prefix: "chirey", logo: Agreements.chirey },
    { prefix: "jac", logo: Agreements.jac },
    { prefix: "mg", logo: Agreements.mg },
  ];

  getLogoUrl(paramKey = "subdomain"): string {
    const urlParams = new URLSearchParams(window.location.search);
    const subParam = urlParams.get(paramKey);

    const subdomain = (subParam || this.getSubdomain()).toLowerCase();

    const match = this.logoMap.find((entry) => subdomain.startsWith(entry.prefix));
    return match ? match.logo : undefined;
  }

  private getSubdomain(): string {
    const parts = window.location.hostname.split(".");
    return parts.length >= 3 ? parts[0] : "localhost";
  }
}
